import React from 'react';
import { RSAA } from 'redux-api-middleware';
import TechIMG from '@/assets/img/news/tech3.jpg';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';
import ColorLink from '@/components/UIKit/ColorLink';

const url = `${process.env.BACKEND_URL}/news`;

export const UNEXEPTABLE_PATHES = [
  'run/exam',
  'run/simulate',
  'olimpic/flash',
  'olimpic/pre-run',
  'news',
  'feed',
  'products',
  'purchase',
];

export const NEWS_FORM = 'NEWS_FORM';
export const GET_NEWS = 'GET_NEWS';
export const GET_NEWS_INFO = 'GET_NEWS_INFO';
export const CREATE_NEWS = 'CREATE_NEWS';
export const EDIT_NEWS = 'EDIT_NEWS';
export const DELETE_NEWS = 'DELETE_NEWS';
export const GET_FULLSCREEN_NEWS = 'GET_FULLSCREEN_NEWS';
export const HIDE_FULLSCREEN_NEWS = 'HIDE_FULLSCREEN_NEWS';

export const NEWS_TYPES = [
  {
    value: 'default',
    label: 'DEFAULT_NEWS',
    color: 'black',
    background: 'white',
  },
  {
    value: 'update',
    label: 'UPDATE_NEWS',
    color: 'white',
    background: `url(${TechIMG})`,
  },
  {
    value: 'feathers',
    label: 'FEATHERS_NEWS',
    color: '',
    background: '',
  },
  {
    value: 'white',
    label: 'WHITE_NEWS',
    color: '',
    background: '',
  },
  {
    value: 'blue',
    label: 'BLUE_NEWS',
    color: '',
    background: '',
  },
  {
    value: 'red',
    label: 'RED_NEWS',
    color: '',
    background: '',
  },
  {
    value: 'yellow',
    label: 'YELLOW_NEWS',
    color: '',
    background: '',
  },
  {
    value: 'green',
    label: 'GREEN_NEWS',
    color: '',
    background: '',
  },
  {
    value: 'purple',
    label: 'PURPLE_NEWS',
    color: 'white',
    background:
      'linear-gradient(100deg, rgba(167,46,252,1) 0%, rgba(61,11,140,1) 100%)',
  },
  // {
  //   value: '',
  //   label: '',
  //   color: '',
  //   background: '',
  // },
]; // TODO: winter, new year, halloween,

export const elements = [
  {
    name: 'LINK',
    label: 'link',
    component: ([link, text, color]) => (
      <ColorLink to={link} color={color}>
        {text}
      </ColorLink>
    ),
    sample: '[LINK| https://uamap.online| Текст ссылки| цвет]',
  },
  {
    name: 'CUSTOM',
    label: 'custom_text',
    component: ([
      text,
      fontWeight,
      fontSize,
      color,
      fontFamily,
      textDecoration,
    ]) => (
      <span
        style={{
          ...(fontWeight === 'italic'
            ? { fontStyle: 'italic' }
            : { fontWeight }),
          color,
          fontSize,
          fontFamily,
          textDecoration,
        }}
      >
        {text}
      </span>
    ),
    sample:
      '[CUSTOM| Настраиваемый текст (некоторые значения можно оставить пустыми; но разделители нужны)| стиль| размер| цвет| шрифт| подчеркивания]',
  },
];

export function parseNewsContent(content) {
  if (!content) return '';

  const paragraphs = content.split('\n');

  const items = paragraphs.map(paragraph => {
    const samples = paragraph.split('[');

    const components = samples.map(s => {
      if (s.includes(']')) {
        const sample = s.slice(0, s.indexOf(']'));

        const [name, ...args] = sample.split('|').map(i => i.trim());

        const elem = elements.find(item => name === item.name);

        return <> {elem?.component(args) || sample} </>;
      }
      return <> {s} </>;
    });

    return <p>{components}</p>;
  });

  return <>{items}</>;
}

// Init state
const initialState = {
  list: [],
  fullscreen: [],
  opened: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NEWS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_NEWS_INFO:
      return {
        ...state,
        opened: action.payload,
      };
    case GET_FULLSCREEN_NEWS:
      return {
        ...state,
        fullscreen: action.payload,
      };
    case HIDE_FULLSCREEN_NEWS:
      return {
        ...state,
        fullscreen: state.fullscreen.filter(
          news => news._id !== action.meta.newsId
        ),
      };
    case CREATE_NEWS:
      return {
        ...state,
        [action.meta]: action.payload,
      };
    default:
      return state;
  }
};

// Actions
export const fetchUserNews = newsType => ({
  [RSAA]: {
    endpoint: `${url}/?type=${newsType || ''}`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: GET_NEWS,
      },
    })),
  },
});

export const fetchNews = () => ({
  [RSAA]: {
    endpoint: `${url}/all`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: GET_NEWS,
      },
    })),
  },
});

export const fetchNewsFullscreen = () => ({
  [RSAA]: {
    endpoint: `${url}/fullscreen`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: GET_FULLSCREEN_NEWS,
      },
    })),
  },
});

export const fetchNewsInfo = id => ({
  [RSAA]: {
    endpoint: `${url}/${id}`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: GET_NEWS_INFO,
      },
    })),
  },
});

export const fetchCreateNews = form => ({
  [RSAA]: {
    endpoint: `${url}/`,
    method: 'POST',
    body: JSON.stringify(form),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: CREATE_NEWS,
      },
    })),
  },
});

export const fetchEditNews = (id, form) => ({
  [RSAA]: {
    endpoint: `${url}/${id}`,
    method: 'POST',
    body: JSON.stringify(form),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: EDIT_NEWS,
      },
    })),
  },
});
export const fetchSaveLastReadNews = (id, form) => ({
  [RSAA]: {
    endpoint: `${url}/last/${id}`,
    method: 'POST',
    body: JSON.stringify(form),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: EDIT_NEWS,
      },
    })),
  },
});

export const fetchDeleteNews = id => ({
  [RSAA]: {
    endpoint: `${url}/${id}`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: DELETE_NEWS,
      },
    })),
  },
});

export const fetchHideFullscreenNews = id => ({
  [RSAA]: {
    endpoint: `${url}/hide-fullscreen/${id}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: HIDE_FULLSCREEN_NEWS,
        newsId: id,
      },
    })),
  },
});

export default reducer;
